export function formatCommissioningMeasureReason(measureReason) {
  if (!measureReason) {
    return null;
  }

  if (typeof measureReason !== 'object') {
    return String(measureReason);
  }

  const { label, code } = measureReason;

  if (label && code) {
    return `${label} (${code})`;
  }

  return label || code || null;
}
